/**
 *
 * User Profile components
 *
 */

import React from 'react';

import { useFlags } from '@flagsmith/flagsmith/react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { featureFlags, isFeatureEnabled } from 'app/flagsmith/features';
import { usePageContentContext } from 'components/Layout';
import { SideNav, SideNavMenuItemProps } from 'components/Navigation/SideNav';
import { selectApp } from 'containers/App/selectors';

import { UserProfileComponentProps } from '../types';

import { Permissions } from './Permissions';
import { Profile } from './Profile';
import { Security } from './Security';
import { UserSession } from './UserSession';

export const UserProfileComponent = (props: UserProfileComponentProps) => {
  const {
    roles,
    apiToken,
    classification,
    memberships,
    allMemberships,
    allRoles,
    path,
    ...rest
  } = props;

  const { user, userAuth } = useSelector(selectApp);
  const {
    username,
    email,
    first_name,
    last_name,
    organization,
    id,
  } = user.info;

  const { contentHeight } = usePageContentContext();
  // Preserve the Security tab after enrollment; expose self-service only on the current user's profile.
  const [searchParams, setSearchParams] = useSearchParams();
  const flags = useFlags([featureFlags.mfa]);
  const showSecurity =
    !path &&
    organization !== 'master' &&
    isFeatureEnabled(flags[featureFlags.mfa]);

  const menuItems: SideNavMenuItemProps[] = [
    {
      title: 'Profile',
      key: 'profile',
      component: (
        <Profile
          {...rest}
          firstName={first_name}
          lastName={last_name}
          orgName={organization}
          email={email}
          username={username}
          guid={id}
          createdTimestamp={userAuth.data.created_at}
        />
      ),
    },
    {
      title: 'Permissions',
      key: 'permissions',
      component: <Permissions />,
    },
    // { title: 'Timeline', key: 'timeline', component: <UserTimeline /> },
    { title: 'Sessions', key: 'sessions', component: <UserSession /> },
    ...(showSecurity
      ? [{ title: 'Security', key: 'security', component: <Security /> }]
      : []),
  ];
  return (
    <SideNav
      menuItems={menuItems}
      height={contentHeight + 'px'}
      styles={{ menuItem: { fontWeight: 400 } }}
      current={
        showSecurity && searchParams.get('tab') === 'security'
          ? 'security'
          : searchParams.get('tab') === 'sessions'
          ? 'sessions'
          : searchParams.get('tab') === 'permissions'
          ? 'permissions'
          : 'profile'
      }
      onChange={key =>
        setSearchParams(previous => {
          previous.set('tab', String(key));
          return previous;
        })
      }
    />
  );
};
